import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { SelectedSkillForAssignment } from '../../models/Assignment';

export interface AssignmentSkillState {
  value: { skill: SelectedSkillForAssignment | null };
}

const initialState: AssignmentSkillState = { value: { skill: null } };

export const assignmentSelectedSkillSlice = createSlice({
  name: 'AssignmentSkill',
  initialState,
  reducers: {
    setSelectedSkillAssignment: (
      state: AssignmentSkillState,
      action: PayloadAction<SelectedSkillForAssignment | null>,
    ) => {
      state.value.skill = action.payload;
    },
  },
});

export const selectedAssignmentSkill = (state: RootState) => state.assignmentSkill.value;

export const { setSelectedSkillAssignment } = assignmentSelectedSkillSlice.actions;

export default assignmentSelectedSkillSlice.reducer;
